import { render, staticRenderFns } from "./ResetRecoveryCodes.vue?vue&type=template&id=13ecefae&"
import script from "./ResetRecoveryCodes.vue?vue&type=script&lang=js&"
export * from "./ResetRecoveryCodes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports